<template>
    <div>
        <v-snackbar
        v-model="snackbarVerify"
        :vertical="vertical"
        color="red"
        :timeout="10000" top
            >
        {{ text }}
        <v-btn
            color="white"
            text
            @click="snackbarVerify = false"
        >
            Close
        </v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbar" :timeout="100000" top :color="color">
            <span>{{message}}</span> 
            <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-container>
            <h3 class="text-center mt-3">EARN CRYPTO</h3>
            <v-toolbar flat>
                <v-btn text @click="refresh()">
                    <span class="black--text font-weight-bold">REFRESH</span>
                    <v-icon color="green">mdi-refresh</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                
                <v-checkbox v-model="checkbox" color="green" class="mt-5" @change="fetchoffer()"></v-checkbox>
                <span class="black--text font-weight-bold mr-2 hidden-sm-and-down">HIDE UNAVAILABLE</span>
                <span class="black--text font-weight-bold hidden-md-and-up">HIDE UNAVAILABLE</span>
                <v-select
                    :items="countries"
                    label="Country"
                    dense
                    solo
                    color="green"
                    class="mt-8 mx-2 hidden-sm-and-down"
                    style="width:1px"
                    @change="onChange2($event)"
                ></v-select>
                
                <v-select
                    :items="amount"
                    label="Amount"
                    dense
                    solo
                    color="green"
                    class="mt-8 hidden-sm-and-down"
                    style="width:1%"
                    @change="onChange($event)"
                ></v-select>
                
            </v-toolbar>
            <v-toolbar class="hidden-md-and-up mb-1" flat>
                <v-select
                    :items="countries"
                    label="Country"
                    dense
                    solo
                    color="green"
                    class="mt-8 mx-2"
                    @change="onChange2($event)"
                ></v-select>
                <v-spacer></v-spacer>
                <v-select
                    :items="amount"
                    label="Amount"
                    dense
                    solo
                    color="green"
                    class="mt-8"
                    @change="onChange($event)"
                ></v-select>
                
            </v-toolbar>
            <!-- <v-row>
                <v-col cols="12" md="8" sm="6">
                    <v-btn text>
                        <span class="black--text font-weight-bold">REFRESH</span>
                        <v-icon color="green">mdi-refresh</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                    <v-checkbox v-model="checkbox" color="green d-inline" class="mt-5"></v-checkbox>
                    <span class="black--text font-weight-bold">HIDE UNAVAILABLE</span>
                
                </v-col>
            </v-row> -->
            <!-- Display Earn when user is logged in -->
            <template v-if="this.$store.state.auth.isUserLogged===true">
                <v-data-table
                    :headers="headers"
                    :items="offers"
                    class="elevation-1 test"
                    :loading="loadTable"
                    no-data-text="No Recent Offers For Display"
                    hide-default-footer
                >
                
                    <template v-slot:item.rating="{ item }"> 
                        <v-rating v-model="item.ratings" small color="orange" class="pa-0 ma-0 d-inline" readonly dense>
                        </v-rating>
                        <span class="black--text">{{item.noOfRatings}}</span>
                    </template>
                    <template v-slot:item.discount="{item}">
                        <span class="black--text">{{item.discount}}%</span>
                    </template>
                    <template v-slot:item.totalPay="{item}" >
                        <span class="black--text" v-if="userId===item.shopperId">${{item.totalPay}}</span>
                        <span class="black--text" v-if="userId!==item.shopperId">${{item.priceEarner}}</span>
                    </template>
                    
                   <template v-slot:item.btcPrice="{item}">
                        <span class="black--text" v-if="userId===item.shopperId">{{item.btcPrice}}</span>
                        <span class="black--text" v-if="userId!==item.shopperId">{{item.priceEarnerBtc}}</span>
                    </template>
                    <template v-slot:item.count="{ item }" > 
                        <v-img :src="getSrc(item.country)" height="50px" width="40px" contain class="ma-0"></v-img>
                    </template>
                    <!-- <template v-slot:item.count="{item}" v-if="country==='all'"> 
                        <v-img :src='getSrc(item.country)' height="50px" width="40px" contain class="ma-0"></v-img>
                    </template> -->
                    <template v-slot:item.act="{ item }"> 
                        <v-btn rounded color="green" @click="getOffer(item.id)" :loading="loading" v-if="userId!==item.shopperId & item.status!=='Accepted'&!item.levelUp" :disabled="refreshPage" class="white--text">EARN</v-btn>
                        <v-btn text style="border: 1px solid grey" class="pa-2 green--text" v-if="userId===item.shopperId" @click="getOrderById(item.id)">YOUR ORDER</v-btn>
                        <span text class="pa-2 red--text font-weight-bold" v-if="item.levelUp===true" >LEVEL UP</span>
                        <v-btn text style="border: 1px solid grey" class="pa-2 green--text" v-if="userId===item.earnerId & item.status==='Accepted'" @click="continueOrder(item.id, item.status)" :disabled="refreshPage">CONTINUE</v-btn>
                    </template>
                    <template v-slot:item.action="{ item }"> 
                        <span style="border: 2px solid teal" class="pa-2" v-if="item.taxPaid===1">TAX PAID</span>
                        <span style="border: 2px solid teal" class="pa-2" v-if="item.onlyPrime===1">ONLY PRIME</span>
                    </template>

                </v-data-table>
            </template>
            <!-- Displar Earns when user is not logged in -->
            <template v-if="this.$store.state.auth.isUserLogged===false">
                <v-data-table
                    :headers="headers"
                    :items="offersAll"
                    class="elevation-1 test"
                    :loading="loadTable"
                    no-data-text="No Recent Offers For Display"
                    hide-default-footer
                >
                
                    <template v-slot:item.rating="{ item }"> 
                        <v-rating v-model="item.ratings" small color="orange" class="pa-0 ma-0 d-inline" readonly dense>
                        </v-rating>
                        <span class="black--text">{{item.noOfRatings}}</span>
                    </template>
                    <template v-slot:item.discount="{item}">
                        <span class="black--text">{{item.discount}}%</span>
                    </template>
                    <template v-slot:item.totalPay="{item}">
                        <span class="black--text">${{item.priceEarner}}</span>
                    </template>
                   <template v-slot:item.btcPrice="{item}">
                        <span class="black--text">{{item.priceEarnerBtc}}</span>
                    </template>
                    <template v-slot:item.count="{ item }" > 
                        <v-img :src="getSrc(item.country)" height="50px" width="40px" contain class="ma-0"></v-img>
                    </template>
                    <template v-slot:item.act="{ item }"> 
                        <v-btn rounded color="green" class="white--text" @click="getOffer(item.id)" :loading="loading" :disabled="refreshPage">EARN</v-btn>
                    </template>
                    <template v-slot:item.action="{ item }"> 
                        <span style="border: 2px solid teal" class="pa-2" v-if="item.taxPaid===1">TAX PAID</span>
                        <span style="border: 2px solid teal" class="pa-2" v-if="item.onlyPrime===1">ONLY PRIME</span>
                    </template>

                </v-data-table>
            </template>
            <v-dialog v-model="dialog"  persistent>
                <v-row no-gutters justify="center">
                    <v-col cols="12" sm="10" md="7" lg="5">
                        <h3 class="text-center pa-3 mb-0" style="background-color:#E0E0E0" v-if="e1===1">OFFER DETAILS</h3>
                        <h3 class="text-center pa-3 mb-0" style="background-color:#E0E0E0" v-if="e1===2">PURCHASE</h3>
                        <h3 class="text-center pa-3 mb-0" style="background-color:#E0E0E0" v-if="e1===3">COMPLETED</h3>
                
                        <v-stepper v-model="e1">
                            <v-stepper-header style="background-color:#E0E0E0 !important">
                                <v-stepper-step :complete="e1 > 1" step="1" color="green"><span class="white--text">Accept</span></v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="e1 > 2" step="2" color="green"><span class="white--text">Purchase</span></v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step step="3" color="green"><span class="white--text">Complete</span></v-stepper-step>
                            </v-stepper-header>

                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <v-card class="" height="160px" flat>
                                        <v-toolbar flat>
                                            <v-card-text class="black--text">$ {{offerById.priceEarner}} <span class="d-block grey--text font-weight-bold">USD</span></v-card-text>
                                            
                                            <v-spacer></v-spacer>
                                            <v-img src="/333.jpg" contain height="50px"></v-img>
                                            <v-spacer></v-spacer>
                                            <v-card-text class="black--text">{{offerById.priceEarnerBtc}} <span class="d-block grey--text font-weight-bold">BTC</span></v-card-text>
                                            
                                        </v-toolbar>
                                        

                                        <h4 class="text-center ma-2">BTC RATE: ${{BtcRate}} / BTC</h4>
                                    </v-card>
                                    <v-card flat class="mx-auto">
                                        <v-row class="mx-auto">
                                            <v-col cols="12" md="4" sm="4">
                                                <v-card-text><v-img :src='getSrc(offerById.country)' height="20px" width="40px" contain class="ma-0"></v-img></v-card-text>
                                            </v-col>
                                            <v-col cols="12" md="8" sm="8">
                                                <v-card-text>Item Shipped To {{offerById.country}}</v-card-text>
                                            </v-col>
                                        </v-row>
                                        <v-card-text>
                                            <h3 class="text-center grey--text">ITEMS TO PURCHASE</h3>
                                            <v-row v-for="item in offerItems" :key="item.id"  class="mx-auto">
                                                <v-col cols="12" md="9" sm="9">
                                                    <v-card-text class="pa-1 black--text">{{item.itemName}}</v-card-text> 
                                                </v-col >
                                                <v-col cols="12" md="3" sm="3">
                                                    <v-card-text class="text-right pa-1 black--text font-weight-bold">$ {{item.price}}</v-card-text>
                                                </v-col>
                                            </v-row>
                                            <v-row  class="mx-auto">
                                                <v-col cols="12" md="9" sm="9">
                                                    <v-card-text class="pa-1 black--text">Shipping Fee:</v-card-text>
                                                </v-col>
                                                <v-col cols="12" md="3" sm="3">
                                                    <v-card-text class="text-right pa-1 black--text font-weight-bold">{{offerById.shippingFee}}</v-card-text>
                                                </v-col>
                                            </v-row>
                                            <v-row  class="mx-auto">
                                                <v-col cols="12" md="9" sm="9">
                                                    <v-card-text class="pa-1 black--text">Tax Fee:</v-card-text>
                                                </v-col>
                                                <v-col cols="12" md="3" sm="3">
                                                    <v-card-text class="text-right pa-1 black--text font-weight-bold">{{offerById.taxFee}}</v-card-text>
                                                </v-col>
                                            </v-row>
                                            <v-divider></v-divider>
                                            <v-row  class="mx-auto">
                                                <v-col cols="12" md="9" sm="9">
                                                    <v-card-text class="pa-1 black--text">Total</v-card-text>
                                                </v-col>
                                                <v-col cols="12" md="3" sm="3">
                                                    <v-card-text class="text-right pa-1 black--text font-weight-bold">${{offerById.priceEarner}}</v-card-text>
                                                </v-col>
                                            </v-row>

                                        </v-card-text>
                                    </v-card>

                                    <div style="background-color:#E0E0E0" class="pa-7 mt-3">
                                        <!-- <div class="text-center" style="background-color:green; cursor:pointer; border-radius:10px"> -->
                                        <div class="text-center">
                                            <v-btn width="100%" large color="green" @click="acceptOffer()" class="ma-2" dark :loading="loading"> ACCEPT OFFER </v-btn>
                                        </div>
                                        <div class="text-center">
                                            <v-btn color="red" large dark class="ma-2" width="100%" @click="dialog=false">NO THANKS</v-btn>
                                        </div>
                                        
                                    </div>
                                    
                                </v-stepper-content>

                                <v-stepper-content step="2" class="ma-0 pa-0">
                                    <v-toolbar color="yellow darken-1" flat>
                                        <v-spacer></v-spacer>
                                        <v-icon >mdi-clock</v-icon>
                                        <span class="ma-2">Time Left: </span>
                                        <timer :time-left="timeLeft"/>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card
                                        flat
                                        class="mb-12"
                                        color="#f8f8f8"
                                        >
                                        <v-card-text class="black--text">
                                            <ol  class="">
                                                <li class="pa-3">Purchase <b>Amazon</b> Items.</li>
                                                <div>
                                                    <a :href="offerById.purchaseUrl"  target="_blank" style="width:400px"><v-btn color="blue" large dark class="ma-2" width="100%">PURCHASE</v-btn></a>
                                                    <!-- <a href="www.google.com">PURCHASE</a> -->
                                                    <!-- <a :href="offerById.wishlistUrl"  target="_blank" dark><span class="white--text text-center">PURCHASE</span></a> -->
                                                </div>
                                                <li class="pa-3">Select <b>Gift Registry Address</b> Checkout.</li>
                                                <li class="pa-3">Enter the <b>Confirmation Message</b> from Amazon</li>
                                                <v-form ref="form1">
                                                    <!-- <v-sub-header>Order Number</v-sub-header>
                                                    <v-text-field solo label="Order Number" class="mb-0" name="offer" v-model="amazonOrderId" type="text" color="grey" :rules="orderRules"></v-text-field>
                                                    <v-sub-header>Estimated Delivery Date</v-sub-header>
                                                    <v-menu
                                                        v-model="menu2"
                                                        :close-on-content-click="false"
                                                        transition="scale-transition"
                                                        offset-y
                                                        max-width="290px"
                                                        min-width="290px"
                                                        >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                v-model="date"
                                                                prepend-icon="event"
                                                                readonly
                                                                solo 
                                                                v-on="on"
                                                                color="grey" :rules="dateRules"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="date" no-title @input="menu2 = false"></v-date-picker>
                                                    </v-menu> -->
                                                    <v-textarea v-model="confirmMessage" solo label="0909" placeholder="Order Number=123-4567891-2345678, Estimated Delivery Date:May 19, 2020" :rules="confirmMessageRules">
                                                    </v-textarea>
                                                </v-form>
                                                
                                                <li class="pa-3"><b>Paste Order Link.</b></li>
                                                <v-form ref="form">
                                                    <v-textarea solo  name="offer" v-model="orderLink"  color="grey" :rules="orderLinkRules" ></v-textarea>

                                                </v-form>
                                            </ol>
                                        </v-card-text>
                                    
                                    </v-card>

                                    <div style="background-color:#E0E0E0" class="pa-7 mt-3">
                                        <div class="text-center">
                                            <v-btn width="100%" large color="green" @click="confirmOrder()" class="ma-2" dark :loading="loading" v-if="autocancel===false"> CONFIRM ORDER</v-btn>
                                            <v-btn width="100%" large color="green" @click="confirmOrder()" class="ma-2"   disabled v-if="autocancel===true"> CONFIRM ORDER</v-btn>
                                        </div>
                                        <div class="text-center">
                                            <v-btn color="red" large dark class="ma-2" width="100%" @click="cancelOrder()" :loading="loading" v-if="autocancel===false">CANCEL ORDER</v-btn>
                                            <v-btn color="red" large  class="ma-2" width="100%" @click="cancelOrder()" disabled v-if="autocancel===true">CANCEL ORDER</v-btn>
                                        </div>
                                        
                                    </div>
                                </v-stepper-content>

                                <v-stepper-content step="3">
                                        <!-- <v-card
                                        class="mb-12"
                                        color="grey lighten-1"
                                        height="200px"
                                        ></v-card> -->
                                    <v-card class="ma-6">
                                        <!-- <v-img src="/verified.png"></v-img> -->
                                        <v-card-text class="text-center">
                                            <v-icon color="green" class="ma-3">mdi-check-bold</v-icon>
                                            <v-divider vertical></v-divider>
                                            Your Order Has Been Confirmed SuccessFully
                                            </v-card-text>
                                    </v-card>
                                    <div style="background-color:#E0E0E0" class="pa-7 mt-3">
                                        <div class="text-center">
                                            <v-btn width="100%" large color="green" @click="getOrder()" class="ma-2" dark> VIEW ORDER</v-btn>
                                        </div>
                                        <div class="text-center">
                                            <v-btn color="red" large dark class="ma-2" width="100%" @click="dialog=false">OKAY</v-btn>
                                        </div>
                                        
                                    </div>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-col>
                    <v-col style="background-color:#E0E0E0"  cols="12" sm="4" md="5" class="hidden-sm-and-down" v-if="e1===2">
                        <!-- <v-container class="fill-height">

                            <v-row align="center" justify="center" no-gutters>
                                <v-img src="/Capture1.jpg" contain></v-img>
                                <div></div>
                                <v-img src="/Capture2.jpg" contain=""></v-img> 
                            </v-row>
                            
                        </v-container> -->
                        <v-card-actions style="margin-top:365px" flat class="ml-n7">
                            <v-icon color="green" x-large>mdi-arrow-left</v-icon>
                            <v-img src="/Capture1.jpg" contain="" width="100px"></v-img>
                        </v-card-actions>
                         <v-card-actions  flat class="ml-n7" style="margin-top:110px;">
                            <v-icon color="green" x-large class="mt-n12">mdi-arrow-left</v-icon>
                            <v-img src="/Capture2.jpg" contain width="100px"></v-img>
                        </v-card-actions>
                        
                        
                    </v-col>
                </v-row>
                
            </v-dialog>

        </v-container>
        
    </div>
</template>
<script>
import timer from '../components/timer'
export default {
    components:{
        timer,
    },
    data(){
        return{
            timerInterval: null, 
            confirmMessage:'',
            timeLimit: 1800,
            timePassed: 0,
            checkbox:true,
            loading:false,
            loadTable:false,
            e1:1,
            snackbar:false,
            color:"",
            message:"",
            dialog:false,
            
            headers:[
                {
                    text: '',
                    align: 'start',
                    value: 'count',
                    class: 'subtitle-2 black--text',
                },
                { text: 'RATE', value: 'discount', sortable: false, class: 'subtitle-2 black--text' },
                { text: 'PRICE', value: 'totalPay', sortable: false, class: 'subtitle-2 black--text' },
                { text: 'BTC AMOUNT', value: 'btcPrice', sortable: false, class: 'subtitle-2 black--text' },
                { text: 'SHOPPER', value: 'username',sortable: false, class: 'subtitle-2 black--text' },
                { text: 'RATING', value: 'rating', sortable: false, class: 'subtitle-2 black--text' },
                { text: '', value: 'action', sortable: false, class: 'subtitle-2 black--text' },
                { text: '', value: 'act', sortable: false, class: 'subtitle-2 black--text' },
            ],
            countries:[
                "ALL", "US", "CANADA", "MEXICO", "UK", "GERMANY", "JAPAN"
            ],
            amount:[
                "ALL", "$5-$50", "$50-$100", "$100-$999"
            ],
            date: '',
            menu2: false,
            orderRules:[v => !!v || 'Order number is required'],
            confirmMessageRules:[v => !!v || 'Confirm Message is required'],
            dateRules:[v => !!v || 'Date is required'],
            orderLinkRules:[v => !!v || 'Order link is required'],
            amazonOrderId:'',
            orderLink:'',
            userId: this.$store.state.auth.logindetails.id,
            snackbarVerify:false,
            text: 'Your account has not been verified! Check your mail for verification link',
            vertical: true,
            autocancel:false,
            refreshPage:false,
            from:0,
            to:999,
            country:'',
            src:'/mxlogo.png'
            
        }
    },
    created(){
        this.headers[0].text='COUNTRY'
        this.country= 'all'
        const userLogged= this.$store.state.auth.isUserLogged
        const userVerified = this.$store.state.auth.logindetails.isVerified
        if(userLogged===true&&userVerified===0){
            this.snackbarVerify=true
        }
        const isUserLogged= this.$store.state.auth.isUserLogged
        const isUserVerified = this.$store.state.auth.logindetails.isVerified
        if(isUserLogged===true&&isUserVerified===1){
            this.refreshPage = true
            this.loadTable = true
            this.$store.dispatch("GetOffers", {"type":'checked', "from":this.from, "to":this.to, "country":'all'})
            .then((success)=>{
                console.log(success)
                this.loadTable=false
                this.refreshPage= false
                console.log('Offers Loaded')
            })
            .catch(()=>{
                this.loadTable = false
                console.log('Offers not loaded')
            });

        }else{
            this.refreshPage = true
            this.loadTable = true
            this.$store.dispatch("GetOffersAll", {"type":'checked', "from":this.from, "to":this.to, "country":'all'})
            .then(()=>{
                this.loadTable=false
                this.refreshPage= false
                
                console.log('Offers Loaded')
            })
            .catch(()=>{
                this.loadTable = false
                console.log('Offers not loaded')
            });

        }
        
        
        // gET BTC RATE
        this.$store.dispatch("GetBtcRate")
        .then(()=>{
            
        })
        .catch((error)=>{
            console.log(error);
        })
            
    },
    computed:{
        offers(){
            if(this.$store.state.offer.Offers){
                let x= this.$store.state.offer.Offers
                for (let j=0; j<x.length; j++){
                    x[j].totalPay = parseFloat(x[j].totalPay).toFixed(2)
                    x[j].priceEarner = parseFloat(x[j].priceEarner).toFixed(2)
                    x[j].btcPrice = parseFloat(x[j].btcPrice).toFixed(8)
                    x[j].priceEarnerBtc = parseFloat(x[j].priceEarnerBtc).toFixed(8)
                }
                return x
            }else{
                return []
            }
            
        },
        offersAll(){
            if(this.$store.state.offer.Offers){
                let x= this.$store.state.offer.OffersAll
                for (let j=0; j<x.length; j++){
                    x[j].totalPay = parseFloat(x[j].totalPay).toFixed(2)
                    x[j].priceEarner = parseFloat(x[j].priceEarner).toFixed(2)
                    x[j].btcPrice = parseFloat(x[j].btcPrice).toFixed(8)
                    x[j].priceEarnerBtc = parseFloat(x[j].priceEarnerBtc).toFixed(8)
                }
                return x
            }else{
                return []
            }
            
        },
        countryText(){
            return 'Us'
        },
        offerById(){
           let x= this.$store.state.offer.OfferById
           let y ={}
           if(x.offer){
               x.offer[0].priceEarner = parseFloat(x.offer[0].priceEarner).toFixed(2)
               x.offer[0].priceEarnerBtc = parseFloat(x.offer[0].priceEarnerBtc).toFixed(8)
               return x.offer[0]
           }else{
            return y
           }
        },
        offerItems(){
            let p=  this.$store.state.offer.OfferById
            let q=[]
            if(p.offerItems){
                return p.offerItems
            }else{
                return q
            }
        },
        BtcRate(){
            return this.$store.state.offer.BtcRate.toFixed(8)
        },
        timeLeft() {
            return this.timeLimit - this.timePassed
        }
    },
    methods:{
        onChange(event) {
            if(event==="$5-$50"){
                this.from=5
                this.to= 50
            }else if(event==='$50-$100'){
                this.from = 50
                this.to =100
            }else if(event==='$100-$999'){
                this.from=100
                this.to=999
            }else{
                this.from= 0
                this.to =999
            }
            if(this.$store.state.auth.isUserLogged===true&this.$store.state.auth.logindetails.isVerified===1){
                this.fetchoffer()
            }else{
                this.fetchofferAll()
            }
            
        },
        onChange2(event) {
            if(event==="US"){
                this.src='/uslogo.png'
                this.country='US'
                this.headers[0].text='US'
                
                
            }else if(event==='CANADA'){
                this.headers[0].text= 'CA'
                this.country= 'CA'
                this.src='/calogo.png'
            }else if(event==='MEXICO'){
                this.headers[0].text='MX'
                this.country='MX'
                this.src='/mxlogo.png'
            }else if(event==='JAPAN'){
                this.headers[0].text='JP'
                this.country='JP'
                this.src='/jplogo.png'
            }else if(event==='UK'){
                this.headers[0].text='UK'
                this.country='UK'
                this.src = '/uklogo.png'
            }else if(event==='GERMANY'){
                this.headers[0].text='DE'
                this.country='DE'
                this.src = '/delogo.png'
            }else if(event==='ALL'){
                this.headers[0].text='COUNTRY'
                this.country='all'
            }
            if(this.$store.state.auth.isUserLogged===true&this.$store.state.auth.logindetails.isVerified===1){
                this.fetchoffer()
            }else{
                this.fetchofferAll()
            }
        
        },
        getOffer(id){ 
            const isUserLogged= this.$store.state.auth.isUserLogged
            const isUserVerified = this.$store.state.auth.logindetails.isVerified
            if(isUserLogged===true&&isUserVerified===1){
                this.loading=true
                this.$store.dispatch("GetOfferById", id)
                .then(()=>{
                    console.log('Offer Gotten')
                    this.loading= false
                    this.dialog= true
                })
                .catch(()=>{
                    console.log('Offer not gotten')
                    this.loading = false
                    this.message="An error occured while getting offer. Please try again later"
                    this.color="red"
                    this.snackbar=true
                });
            }else{
                this.$router.push('./login')
            }
            
            

        },
        acceptOffer(){
            this.loading=true
            let id = this.$store.state.offer.OfferById.offer[0].id
            this.$store.dispatch("AcceptOffer", id)
            .then(()=>{
                this.loading=false
                console.log('Offer Accepted')
                this.$store.dispatch("GetUser", this.$store.state.auth.logindetails.id)
                this.$store.dispatch("GetOffers", {"type":'checked'})
                this.e1= 2
                this.startTimer()
            })
            .catch((error)=>{
                if(error.response.status===409){
                    console.log('Offer not Accepted')
                    this.loading=false
                    this.message="You already have a pending offer.Complete your current offer and try again later"
                    this.color="red"
                    this.snackbar=true
                }else{
                    console.log('Offer not Accepted')
                    this.loading=false
                    this.message="An error occured while accepting offer. Please try again later"
                    this.color="red"
                    this.snackbar=true
                }
                
            });

        },
        confirmOrder(){
            if (this.$refs.form.validate() & this.$refs.form1.validate()){    
                this.loading=true
                this.$store.dispatch("ConfirmOrder",{
                    "amazonOrderMessage":this.confirmMessage,
                    "orderLink": this.orderLink,
                    "wishlistTableId": this.$store.state.offer.OfferById.offer[0].id,
                    "wishlistId": this.$store.state.offer.OfferById.offer[0].wishlistId,
                    "shopperId": this.$store.state.offer.OfferById.offer[0].shopperId,
                    "earnerId": this.$store.state.auth.logindetails.id
                })
                .then((success)=>{
                    console.log('Order Confirmed')
                    this.$store.dispatch("GetUser", this.$store.state.auth.logindetails.id)

                    console.log(success)
                    this.loading=false
                    this.e1=3
                })
                .catch((error)=>{
                    console.log('Order Not Confirmed')
                    this.loading=false
                    // this.message="An error occured while confirming order. Please try again later"
                    this.message= error.response.data.message.toUpperCase()
                    this.color="red"
                    this.snackbar=true
                });
            }
        },
        cancelOrder(){
            this.loading=true
            let id = this.$store.state.offer.OfferById.offer[0].id
            this.$store.dispatch("CancelOrder", id)
            .then(()=>{
                this.loading=false
                console.log('Order Cancelled')
                this.$store.dispatch("GetUser", this.$store.state.auth.logindetails.id)
                this.$store.dispatch("GetOffers", {"type":'checked'})
                this.dialog=false
                this.message="Your Offer has been cancelled"
                this.color="green"
                this.snackbar=true
                this.$forceUpdate()
                this.$router.go(0);

            })
            .catch((error)=>{
                console.log(error)
                console.log('Order not Cancelled')
                this.loading=false
                this.message="An error occurred while cancelling order. Please Try Again Later"
                this.color="red"
                this.snackbar=true
            });

        },
        getOrder(){
            this.$router.push('/orders')
        },
        getOrderById(id){
            this.$store.dispatch("GetOrderById",id)
            .then((success)=>{
                console.log(success);
                this.$router.push('/orders/'+id)
            })
            .catch((error)=>{
                console.log(error);
            });
            
        },
        continueOrder(id, status){
            console.log(id, status)
            this.e1=2
            this.startTimer()
            this.dialog= true

        },
        refresh(){
            
            if(this.$store.state.auth.isUserLogged===true&this.$store.state.auth.logindetails.isVerified===1){
                this.checkbox = true
                this.loadTable= true
                this.refreshPage = true
                
                this.$store.dispatch("GetOffers", {"type":'checked',"from":this.from,"to":this.to, "country":this.country})
                .then(()=>{
                    this.loadTable=false
                    this.refreshPage = false
                    console.log('Offers Loaded')
                })
                .catch(()=>{
                    this.loadTable = false
                    console.log('Offers not loaded')
                });

            
            
            
            }else{
                this.checkbox = true
                this.loadTable= true
                this.refreshPage = true
                
                this.$store.dispatch("GetOffersAll", {"type":'checked',"from":this.from,"to":this.to, "country":this.country})
                .then(()=>{
                    this.loadTable=false
                    this.refreshPage = false
                    console.log('Offers Loaded')
                })
                .catch(()=>{
                    this.loadTable = false
                    console.log('Offers not loaded')
                });

            }
        },
        fetchoffer(){
            if(this.checkbox===true){
                this.loadTable= true
                this.$store.dispatch("GetOffers", {"type":'checked', "from":this.from, "to":this.to, "country":this.country})
                .then(()=>{
                    this.loadTable=false
                    console.log('Offers Loaded')
                })
                .catch(()=>{
                    this.loadTable = false
                    console.log('Offers not loaded')
                });
            }else{
                this.loadTable= true
                this.$store.dispatch("GetOffers", {"type":'unchecked', "from":this.from, 'to':this.to, "country":this.country})
                .then(()=>{
                    this.loadTable=false
                    console.log('Offers Loaded')
                })
                .catch(()=>{
                    this.loadTable = false
                    console.log('Offers not loaded')
                });
            }
        },
        fetchofferAll(){
            
            if(this.checkbox===true){
                this.loadTable= true
                this.$store.dispatch("GetOffersAll", {"type":'checked', "from":this.from, "to":this.to, "country":this.country})
                .then((success)=>{
                    this.loadTable=false
                    console.log('Offers Loaded')
                    console.log(success)
                })
                .catch(()=>{
                    this.loadTable = false
                    console.log('Offers not loaded')
                });
            }else{
                this.loadTable= true
                this.$store.dispatch("GetOffersAll", {"type":'unchecked', "from":this.from, 'to':this.to, "country":this.country})
                .then(()=>{
                    this.loadTable=false
                    console.log('Offers Loaded')
                })
                .catch(()=>{
                    this.loadTable = false
                    console.log('Offers not loaded')
                });
            }
        },
        startTimer() {
            this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
        },
        onTimesUp() {
            clearInterval(this.timerInterval);
        },
        getSrc(country){
            if(country==="US"){
                
                return '/uslogo.png'
            }else if(country==='CA'){
                
                return '/calogo.png'
            }else if(country==='MX'){
                
                return '/mxlogo.png'
            }else if(country==='JP'){
               
                return '/jplogo.png'
            }else if(event==='UK'){
                
                return '/uklogo.png'
            }else if(event==='DE'){
               
                return '/delogo.png'
            }
        }
    },
    watch: {
        timeLeft(newValue) {
            if (newValue === 3) {
                this.message=' You have 3 seconds left to complete this purchase. After which this order will be cancelled and you will be redirected to earn again'
                this.color= 'red'
                this.snackbar = true
            }else if(newValue===0){
                this.onTimesUp();
                this.autocancel = true
                this.cancelOrder()
            }
        }
    }
}
</script>
<style scoped>
    .test .theme--light.v-table { background-color: #00f; }
    /* a {
          background-color: blue;
          border: solid 1px blue;
          border-radius: 5px;
          box-sizing: border-box;
          color:white;
          cursor: pointer;
          display: inline-block;
          font-size: 14px;
          font-weight: bold;
          margin: 0;
          padding: 12px 25px;
          text-decoration: none;
          text-transform: capitalize; 
          width: 80%
      } */
</style>